module.exports = __webpack_public_path__ + "54d102012672abbf1bd2c28487aef049.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/url.jpg
// module id = 969
// module chunks = 0